module.exports = __webpack_public_path__ + "img/aquariums.b557cb25.png";